module.exports = __webpack_public_path__ + "img/palmar-room-6.f6b327d5.jpg";